<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Sales Person</h5>
                <button class="btn btnAS" [userPermissionHandler]="createPermissionHandlerData"
                    (click)="onNewClick()">NEW</button>
            </div>
            <hr />
            <div class="mb-3 d-flex gap-3 align-items-center">

                <div class="form-check form-check-inline">
                    <input class="form-check-input" id="rdAll" type="radio" name="status"
                        [checked]="activeTab === 'All'" (change)="onTabChange('All')" />
                    <label class="form-check-label" for="rdAll">All</label>
                </div>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" id="rdActive" type="radio" name="status"
                        [checked]="activeTab === 'Active'" (change)="onTabChange('Active')" />
                    <label class="form-check-label" for="rdActive">Active</label>
                </div>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" id="rdInactive" type="radio" name="status"
                        [checked]="activeTab === 'Inactive'" (change)="onTabChange('Inactive')" />
                    <label class="form-check-label" for="rdInactive">Inactive</label>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <div class="grid-wrapper position-relative">
                        <div class="block-ui" *ngIf="loaderIcon | async">
                            <app-loader></app-loader>
                        </div>
                        <ejs-grid #gridSalesPerson [dataSource]="salesData" height="300" [allowFiltering]="true"
                            (created)='created($event)' (dataBound)='dataBound($event)'
                            (rowSelected)="onRowSelected($event)">
                            <e-columns>
                                <e-column field="SalesmanId" headerText="Sales Person ID" width="150"></e-column>
                                <e-column field="firstName" headerText="First Name" width="150"></e-column>
                                <e-column field="lastName" headerText="Last Name" width="150"></e-column>
                                <e-column field="email" headerText="Email" width="180"></e-column>
                                <e-column field="mobiles" headerText="Mobile" width="180">
                                    <ng-template #template let-data>
                                        {{ formatPhoneNumber(data.mobiles) }}
                                    </ng-template>
                                </e-column>
                                <e-column field="city" headerText="City" width="120"></e-column>
                                <e-column field="StateName" headerText="State" width="100"></e-column>
                                <e-column field="zip" headerText="Zipcode" width="120"></e-column>
                                <e-column field="status" headerText="Active / Inactive" textAlign="Center" width="160"
                                    [template]="statusTemplate"></e-column>
                                <e-column field="Delete" headerText="Delete" width="100" textAlign="Center">
                                    <ng-template #template let-data>
                                        <button class="btn btn-link w-100 h-100 p-0"
                                            [userPermissionHandler]="deletePermissionHandlerData"
                                            (click)="$event.stopPropagation(); $event.preventDefault(); deleteSalesPerson(data.SalesPersonID)">
                                            <img src="./assets/images/delete.svg" class="img-fluid" />
                                        </button>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                        <ng-template #statusTemplate let-data>
                            <span class="d-inline-block rounded-circle" [ngStyle]="{
                                    width: '15px',
                                    height: '15px',
                                    backgroundColor: data.status === 'Active' ? activeColor : inactiveColor
                                  }">
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="salesPersonModal" #salesPersonModal tabindex="-1"
            aria-labelledby="salesPersonModalLabel" aria-hidden="true">
            <form [formGroup]="SalesPersonForm">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="salesPersonModalLabel">Create New Sales Person</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="container-fluid">
                                <div class="row align-items-center mb-3">
                                    <div class="col-md-6 col-lg-4 mt-3 mt-lg-0">
                                        <label class="form-label">Sales Person ID
                                            <span class="required">*</span>
                                        </label>
                                        <input type="text" class="form-control" formControlName="salesPersonID"
                                            maxlength="10">
                                        <div *ngIf="SalesPersonForm.get('salesPersonID').touched && SalesPersonForm.get('salesPersonID').invalid"
                                            class="text-danger">
                                            Sales Person ID is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 d-flex align-items-center mt-4">
                                        <input type="checkbox" class="form-check-input me-2" id="activechecked"
                                            formControlName="salesActive">
                                        <label class="form-check-label" for="activechecked">Active Sales Person</label>
                                    </div>
                                    <div class="col-md-6 col-lg-4 text-start mt-md-3">
                                        <label class="form-label lblMarketLogo">Sales Person Photo</label>
                                        <div class="d-flex">
                                            <div class="logo-box mx-auto position-relative me-3"
                                                style="margin-left: 0px !important;">
                                                <input type="file" accept="image/*" (change)="onLogoSelected($event)"
                                                    class="form-control position-absolute top-0 start-0 w-100 h-100 opacity-0"
                                                    style="cursor: pointer;">
                                                <div
                                                    class="w-100 h-100 d-flex align-items-center justify-content-center p-3">
                                                    <img [src]="logoPreviewUrl" id="logoPreview" class="img-fluid"
                                                        style="pointer-events: none; width: 5.5rem;">
                                                </div>
                                            </div>
                                            <div class="d-block">
                                                <button class="btn btnAS" (click)="addPhoto()">ADD</button>
                                                <br />
                                                <button class="btn btnAS mt-2" (click)="removePhoto()">Remove</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">First Name
                                            <span class="required">*</span>
                                        </label>
                                        <input type="text" class="form-control" formControlName="firstName"
                                            maxlength="50">
                                        <div *ngIf="SalesPersonForm.get('firstName').touched && SalesPersonForm.get('firstName').invalid"
                                            class="text-danger">
                                            First Name is required.
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Last Name</label>
                                        <input type="text" class="form-control" formControlName="lastName"
                                            maxlength="50">
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Email</label>
                                        <input type="text" class="form-control" formControlName="email" maxlength="50"
                                            [class.is-invalid]="SalesPersonForm.get('email')?.invalid && SalesPersonForm.get('email')?.touched">
                                        <div *ngIf="SalesPersonForm.get('email')?.invalid && SalesPersonForm.get('email')?.touched"
                                            class="text-danger">
                                            Enter a valid mail address.
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">Mobile</label>
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" formControlName="mobile"
                                            maxlength="10" class="sales-person-form-control"
                                            (keypress)="allowOnlyNumbers($event)"
                                            [class.is-invalid]="SalesPersonForm.get('mobile')?.invalid && SalesPersonForm.get('mobile')?.touched"></ejs-maskedtextbox>
                                        <div *ngIf="SalesPersonForm.get('mobile')?.invalid && SalesPersonForm.get('mobile')?.touched"
                                            class="text-danger">
                                            Enter a valid 10-digit mobile number.
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">City</label>
                                        <input type="text" class="form-control" formControlName="city" maxlength="20">
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">State</label>
                                        <select class="form-select" formControlName="state">
                                            <option [ngValue]="null">-- Select State --</option>
                                            <option *ngFor="let state of stateList" [ngValue]="state.StateId">
                                                {{ state.StateName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">ZipCode</label>
                                        <input type="text" class="form-control" formControlName="zipcode"
                                            maxlength="10">
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <label class="form-label">User ID</label>
                                        <select class="form-select" formControlName="selectedUserId">
                                            <option [ngValue]="null">-- Select User --</option>
                                            <option *ngFor="let user of userList" [ngValue]="user.UserId">
                                                {{ user.UserName }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            @if (isEditMode) {
                            <button type="button" class="btn btnAS me-1"
                                [userPermissionHandler]="editPermissionHandlerData" (click)="saveSalesPersonDetails()"
                                [disabled]="SalesPersonForm.invalid || !SalesPersonForm.dirty">
                                Save
                            </button>
                            } @else {
                            <button type="button" class="btn btnAS me-1"
                                [userPermissionHandler]="createPermissionHandlerData" (click)="saveSalesPersonDetails()"
                                [disabled]="SalesPersonForm.invalid">
                                Save
                            </button>
                            }
                            <button type="button" class="btn btn-orange" data-bs-dismiss="modal"
                                (click)="routeBack()">Close</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>